import Dashboard from './subrouters/Dashboard';
import Login from '../pages/Login';
import routes from './subrouters/Dashboard/routes';
import { ComplexRoute } from './components/Routes/Routes';

export default [
  {
    path: '/login',
    label: 'Login',
    element: Login,
  },
  {
    path: '/',
    element: Dashboard,
    label: 'Dashboard',
    routes: routes,
  },
] as Array<ComplexRoute>;
